import * as React from 'react';
import getAdjustedIconClassName from 'owa-mini-icons/lib/utils/getAdjustedIconClassName';
import { formatUserTime, isEqual } from 'owa-datetime';
import { MiniIcons } from 'owa-mini-icons';
import { StartTimeAndEndTimeProps } from '../schema/StartTimeAndEndTime.types';

const styles = require('./StartTimeAndEndTime.scss');
const classNames = require('classnames');

/**
 * Renders start time -> end time
 */
export default function StartTimeAndEndTime(props: StartTimeAndEndTimeProps): JSX.Element {
    const { start, end, className, iconStyles } = props;
    // Show only the start time for 0 minute events
    return (
        <div className={classNames(styles.timing, className)}>
            {isEqual(start, end) ? (
                <span>{formatUserTime(start)}</span>
            ) : (
                <>
                    <span>{formatUserTime(start)}</span>
                    <i
                        aria-hidden={true}
                        className={classNames(
                            iconStyles,
                            getAdjustedIconClassName(MiniIcons.Forward),
                            styles.inlineIcon
                        )}
                    />
                    <span>{formatUserTime(end)}</span>
                </>
            )}
        </div>
    );
}
